import ICoordinate from '../../../map/ICoordinate';

export enum ProductTypeTypes {
    Plan = 1,
    Package = 2,
    Addition = 3,
    Styling = 7,
    Showcase = 8,
    DigitalStyling = 9
}

export enum BookingConditions {
    BookableByAll = 1,
    BookableByAdmin = 3,
    NotBookable = 4
}

export enum ProductAllocationTypes {
    Visible = 2,
    PreChosen = 3
}

export type FirmProduct = {
    id: number;
    name: string;
    productTypeType: number;
    productTypeName: string;
    allocationType: { value: number };
    required: boolean;
    isStylingProduct: boolean;
    hasProductPropertyMeasured: boolean;
    hasProductPropertyEditCustomerImages: boolean;
    hasProductPropertyOnlyCentralBooking: boolean;
    hasProductPropertySunsetPhotography: boolean;
    hasProductPropertyDuskPhotography: boolean;
    bookingCondition: { value: number };
    extraText: string | null;
    priceBrokerFirm: { value: number } | null;
    currencySign: string;
};

export type BrokerFirm = {
    id: number;
    name: string;
    isHeadQuarter: boolean;
    customerType: number;
    isCustomerAllowedToBook: boolean;
};

export type BrokerAgent = {
    id: number;
    name: string;
    availableBrokerFirms: BrokerFirm[];
};

export type ObjectType = {
    id: number;
    name: string;
};

export type PendingOrder = {
    id: string;
    userId: number;
    contentProvider: number;
    address: Partial<PropertyAddress>;
    contact: Partial<PropertyOwner>;
};

export type ExistingOrderData = {
    existingPlanOrderId: number | null;
    allowPlanOrder: boolean | null;
};

export type NewOrder = {
    availableBrokerAgents: BrokerAgent[];
    availablePrivateObjectTypes: ObjectType[];
    availableCommercialObjectTypes: ObjectType[];
    pendingOrder: PendingOrder | null;
    pendingOrderBrokerFirmId: number | null;
    existingOrderData?: ExistingOrderData | null;
};

export type PropertyOwner = {
    ownerFirstName: string;
    ownerLastName: string;
    ownerEmailAddress: string;
    ownerPrimaryPhoneNumber: string;
};

export type PropertyAddress = {
    addressLine1: string;
    addressPostalNumber: string;
    addressCity: string;
    addressDistrict: string;
    objectType: number | null;
    addressPointLocation: ICoordinate | null;
};

export type PropertyInformation = {
    owner: PropertyOwner;
    address: PropertyAddress;
    notes: string;
    extraDeliveryRecipients: string;
};

export type FloorPlanFile = {
    file: File;
    storeyId: number;
};

export type BookingChoice = {
    photographerId: number;
    timeslot: string;
};
